module.exports = __webpack_public_path__ + "img/PayPal.a2605cf5.svg";